<template>
    <div class="main-container">

        <div class="management">
            <h1>Módulo de gestión</h1>
            <div class="tabs">
                <div :class="{'--selected':route.path.includes('preinscriptions')}" @click.stop="router.replace('/management/preinscriptions')">Cohortes</div>
                <div :class="{'--selected':route.path.includes('courses')}" @click.stop="router.replace('/management/courses')">Cursos</div>
                <div :class="{'--selected':route.path.includes('links')}" @click.stop="router.replace('/management/links')">Enlaces</div>
            </div>
            <router-view />
        </div>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.main-container{
    padding: 8px;
    background: #fff;
    min-height: 90vh;
    .management{
        width: 100%;
        max-width: 1116px;
        margin: 0 auto;
        padding: 36px 0;
        h1{
        font-size: 25px;
        font-weight: 700;
        }
        .tabs{
            display: flex;
            margin: 30px 0;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
            >div{
                height: 60px;
                width: 180px;
                @include flex-column;
                justify-content: center;
                font-size: 15px;
                font-weight: 600;
                cursor: pointer;
                &.--selected{
                    color: $green;
                    border-bottom: 2px solid $green;
                    cursor: default;
                }
            }
        }
    }
}




</style>